/* unplugin-vue-components disabled */import { render } from "./xcheckbox.vue?vue&type=template&id=4e5bb7de"
import script from "./xcheckbox.vue?vue&type=script&lang=js"
export * from "./xcheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__